import React, { useEffect } from 'react'
import { useBanner } from '../../context/BannerContext';
import { WSS_URL } from '../../config/apiConfig';
import { useTaskStatus } from '../../context/TaskStatusContext';
import iq_api_v2 from '../../services/iqApiV2';

export default function ReviewAccount({client_name, account_name}) {
    // const { user } = useUser();
    const showBanner = useBanner();

    const { registerTask, getTaskData, getConnectionStatus, deregisterTask } =
        useTaskStatus();

    const TASK_ID = `reviewing_account_${client_name}_${account_name}`;
    const taskData = getTaskData(TASK_ID);
    const isConnected = getConnectionStatus (TASK_ID);

    const handleReviewAccount = async(client_name, account_name) => {
        
        try {
            const postData = {"client": client_name, "account": account_name};
            const response = await iq_api_v2.post(`/review_account`, '', {
                'params': postData
            });
            // console.log("response : ", response)
            if(response?.data?.task_id){
                showBanner({
                    message: "Request has been sent!",
                    title: "Alert",
                    type: "success",
                    duration: 10000,
                });

                registerTask(TASK_ID, `${WSS_URL}/${response?.data?.task_id}`);

            }else{
                showBanner({
                    message: "Something went wront. Please try later.",
                    title: "Alert",
                    type: "error",
                    duration: 10000,
                });
            }

        } catch (error) {
            console.error("Error reviewing accounts:", error);
            showBanner({
                message: "Something went wront. Please try later.",
                title: "Alert",
                type: "error",
                duration: 10000,
            });
        }
    }

    useEffect(() => {
        // console.log("taskData", taskData, isConnected);
        if(isConnected && taskData?.status === 'completed'){
            showBanner({
                message: "Account review data generated successfully ('"+client_name+"' : '"+account_name+"'). Kindly check meta dashboard.",
                title: "Alert",
                type: "success",
                duration: 10000,
            });

            deregisterTask(TASK_ID)
        }
    }, [taskData, isConnected]);

  return (
    <span
        onClick={() => handleReviewAccount(client_name, account_name)}
        className="ml-1 btn btn-success btn-sm cursor_p font11"
        title="Review Account"
    >
        <i className={`fa fa-check ${taskData?.status === 'pending' ? 'blink_review' : '' }`} ></i> Review Account {taskData?.status === 'completed' ? ' - (Reviewed)' : ''}
    </span> 
  )
}
